import { render, staticRenderFns } from "./Gguess.vue?vue&type=template&id=de7c1312&scoped=true&"
import script from "./Gguess.vue?vue&type=script&lang=js&"
export * from "./Gguess.vue?vue&type=script&lang=js&"
import style0 from "./Gguess.vue?vue&type=style&index=0&id=de7c1312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7c1312",
  null
  
)

export default component.exports